const e = {
  body: "'Open Sans', sans-serif",
  heading: "'Merriweather', sans-serif"
}, t = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "36px",
  "4xl": "48px"
}, i = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
}, n = {
  normal: "normal",
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: "2"
}, o = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em"
}, l = {
  h1: {
    fontFamily: "body",
    fontSize: { base: "3xl", md: "4xl" },
    fontWeight: "light",
    lineHeight: { base: "44px", md: "56px" }
  },
  h2: {
    fontFamily: "heading",
    fontSize: { base: "28px", md: "3xl" },
    fontWeight: "normal",
    lineHeight: { base: "40px", md: "48px" },
    fontVariantNumeric: "lining-nums"
  },
  h3: {
    fontFamily: "heading",
    fontSize: { base: "xl", md: "2xl" },
    fontWeight: "bold",
    lineHeight: { base: "32px", md: "36px" },
    fontVariantNumeric: "lining-nums"
  },
  h4: {
    fontFamily: "heading",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "32px" },
    fontVariantNumeric: "lining-nums"
  },
  subheading1: {
    fontFamily: "body",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "36px" },
    textTransform: "uppercase"
  },
  subheading2: {
    fontFamily: "body",
    fontSize: { base: "md", md: "lg" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "28px" }
  },
  body: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "normal",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodyBold: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodySmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "normal",
    lineHeight: { base: "20px", md: "24px" }
  },
  bodyBoldSmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "bold",
    lineHeight: { base: "20px", md: "24px" }
  }
};
export {
  t as fontSizes,
  i as fontWeights,
  e as fonts,
  o as letterSpacings,
  n as lineHeights,
  l as textStyles
};
